<template>
    <div class="testimonial_photo">
        <vueper-slides
            :arrows="true"
            :bullets="true"
            :touchable="true"
            :dragging-distance="70"
            class="no-shadow"
            fixed-height="true">
            <vueper-slide
                v-for="(slide, i) in slides"
                :key="i"
                class="slide">
                <template v-slot:content>
                    <div class="slide-content">
                        <img :src="slide.photo" :alt="slide.author">
                        <h2 class="title">
                            {{slide.content}}
                        </h2>
                        <p>
                        - {{slide.author}}
                        </p>
                        <p v-if="slide.title">
                            {{slide.title}}
                        </p>
                    </div>
                </template>
            </vueper-slide>
        </vueper-slides>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'

export default {
    name: "TestimonialPhoto",
    components: { VueperSlides, VueperSlide },
    props:['slides'],
}
</script>

<style lang="scss" scoped>
.testimonial_photo{
    position: relative;
    &::after {
        content: "";
        background: rgb(2,0,36);
        background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(185,63,95,1) 0%, rgba(123,165,211,1) 100%);
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        position: absolute;
        z-index: -1; 
    }
}
</style>

<style lang="scss">
.testimonial_photo{
    .vueperslides--fixed-height { 
        height: 480px;
    }
    .vueperslide{
        padding: 0 20%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        p {
            margin-top: 20px;
            color: #fff;
            font-size: 17.8px;
            letter-spacing: 1.5px;
            line-height: 28px;
            font-weight: 400;
            margin: 0 auto;
        }
        h2{
            color: #fff;
            text-align: center;
            font-size: 25.5px;
            font-weight: 500;
            line-height: 30px;
            letter-spacing: 1.5px;
        }
        img{
            display: block;
            width: 120px;
            border-radius: 120px;
            margin: 0 auto;
        }
    }
    .vueperslides__bullets{
        top: unset;
        bottom: 0;
        display: none;
        .default {
            width:4px;
            height:4px;
            border-radius: 4px;
            background-color: #fff;
            box-shadow: none;
        }
    }
    .vueperslides__bullet--active{
        .default {
            width:4px;
            height:4px;
            border-radius: 4px;
            color: #000;
            background-color: #000;
            border-width: unset;
            box-shadow: none;
        }
    }
}

@media (max-width: $mobile) { 
    .testimonial_photo{
        .vueperslides--fixed-height { 
            height: 650px;
        }
        .vueperslide{
            padding: 0 2rem;
        }
        .vueperslides__bullets{
            display: flex;
        }
    }
    .vueperslides__arrows{
        display: none;
    }
}

.vueperslide--clone{
    height: 550px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>